import logoText from '@assets/logo.png';

export const Header = () => {
  return (
    <div className="absolute top-0 left-0 w-full h-16 bg-indigo-900 flex justify-center items-center">
      <img src={logoText} alt="logo" className="h-8" />
    </div>
  );
};
